import React from 'react';
import { ProfileValidationAuthContainer } from 'components/profile-validate/ProfileValidationAuthContainer';

const Validate = () => {
  return <ProfileValidationAuthContainer />;
};

export default Validate;
